import Alpine from 'alpinejs';

Alpine.data('header', () => ({
    init() {
        // The header is cached once for the whole site
        // Set the active state dynamically
        let activeLink = this.$root.querySelector(
            'a[href="' + location.pathname + '"], a[href="' + location.origin + '/' + location.pathname + '"]'
        );
        let activeLi = activeLink?.closest('li');
        while (activeLi) {
            activeLi.classList.add('header-menu-item-is-active');
            activeLi = activeLi.parentElement.closest('li');
        }

        // update the language switcher links
        this.$root.querySelectorAll('.header--language-picker-dropdown a').forEach((link) => {
            const alternateLink = document.querySelector(
                `link[rel="alternate"][hreflang="${link.getAttribute('href').substring(1)}"]`
            );
            if (alternateLink) {
                link.href = alternateLink.href;
            }
        });

        // Close desktop menu when Escape key is pressed
        window.addEventListener('keydown', (event) => {
            if (event.key === 'Escape' && !this.isMobile && this.activeSubMenuItemID !== 0) {
                this.activeSubMenuItemID = 0;
                this.activeBrandMenuItemID = 0;
                this.activeModelSliderID = 0;
            }
        });
    },
    isMobile: window.innerWidth < 1024,
    isAtTop: window.pageYOffset < 20,
    searchIsOpen: window.innerWidth < 1024,
    activeSubMenuItemID: 0,
    activeBrandMenuItemID: 0,
    activeModelSliderID: 0,
}));
